'use strict';

angular.module('pmtPlacesApp.services').service('pmtSpecialOpenHourValidationService', [
	'$http',
	function () {
		let dateTimeToday = function () {
			let d = new Date();
			d.setUTCHours(0, 0, 0, 0);
			return d;
		};

		let dateTimeTomorrow = function () {
			const today = new Date();
			const tomorrow = new Date(today);
			tomorrow.setDate(tomorrow.getDate() + 1);
			tomorrow.setUTCHours(0, 0, 0, 0);
			return tomorrow;
		};

		let MIN_DATE = (function () {
			let d = dateTimeToday();
			d.setUTCDate(d.getUTCDate());
			return d;
		})();

		let DATE_TOMORROW = (function () {
			let d = dateTimeTomorrow();
			d.setUTCDate(d.getUTCDate());
			return d;
		})();

		let MAX_DATE = (function () {
			let d = dateTimeToday();
			d.setUTCFullYear(d.getFullYear() + 5);
			return d;
		})();

		let sameDate = function (x, y) {
			return x.start === y.start;
		};

		let startWithin = function (x, y) {
			let xStart = parseInt(x.openTime),
				yStart = parseInt(y.openTime),
				yEnd = parseInt(y.closeTime);
			return x.isClosed || y.isClosed || (xStart > yStart && xStart < yEnd);
		};

		let surrounds = function (x, y) {
			let xStart = parseInt(x.openTime),
				xEnd = parseInt(x.closeTime),
				yStart = parseInt(y.openTime),
				yEnd = parseInt(y.closeTime);

			return xStart >= yStart && xEnd <= yEnd;
		};

		let exactlySame = function (x, y) {
			return JSON.stringify(x) === JSON.stringify(y);
		};

		let hasOverlap = function (items, itemToValidate) {
			let overlap = (items || []).some(function (x) {
				return (
					!exactlySame(x, itemToValidate) &&
					sameDate(x, itemToValidate) &&
					(startWithin(x, itemToValidate) ||
						startWithin(itemToValidate, x) ||
						surrounds(x, itemToValidate) ||
						surrounds(itemToValidate, x))
				);
			});
			return overlap;
		};

		let validateSpecialHourTimespan = function (special) {
			let validTime = function (x) {
				let i = parseInt(x);
				return !isNaN(i) && i >= 0 && i <= 2400;
			};
			let validateTime = function (x) {
				return validTime(x) && (x + '').length === 4;
			};
			let openShouldBeLessThanCloseTime = function () {
				let closeTime = parseInt(special.closeTime || '0'),
					openTime = parseInt(special.openTime || '0');
				if (closeTime > openTime) {
					return true;
				} else if (closeTime < 1159) {
					return true;
				} else {
					return false;
				}
			};

			let valid =
				special.isClosed ||
				(validateTime(special.openTime) &&
					validateTime(special.closeTime) &&
					openShouldBeLessThanCloseTime());
			return valid;
		};

		let validateAllSpecialHours = function (items) {
			if (items == null) {
				return true;
			}
			let valid = items.every(validateSpecialHourTimespan);
			let someOverlap = function () {
				let ho = function (x) {
					return hasOverlap(items, x);
				};
				return items.some(ho);
			};
			return valid && !someOverlap();
		};

		return {
			validateSpecialHourTimespan: validateSpecialHourTimespan,
			validateAllSpecialHours: validateAllSpecialHours,
			hasOverlap: hasOverlap,
			DATE_TOMORROW: DATE_TOMORROW,
			MIN_DATE: MIN_DATE,
			MAX_DATE: MAX_DATE
		};
	}
]);
